import React, { useState, useEffect } from 'react';

const ReferralQuestion = ({ question, onSubmit, onNext, currentAnswer }) => {
  const [selectedOption, setSelectedOption] = useState("");

  // Set initial value when editing
  useEffect(() => {
    if (currentAnswer) {
      // If currentAnswer is a string (display label), find the corresponding value
      if (typeof currentAnswer === 'string') {
        const matchingOption = question.options.find(opt => opt.label === currentAnswer);
        setSelectedOption(matchingOption ? matchingOption.value : currentAnswer);
      } else {
        setSelectedOption(currentAnswer.value || currentAnswer);
      }
    }
  }, [currentAnswer, question.options]);

  const handleOptionChange = (option) => {
    setSelectedOption(option);
    // Don't call onSubmit here - only when Continue is clicked
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    
    if (!selectedOption) return;
    
    // Find the selected option to get the label
    const selectedOptionData = question.options.find(opt => opt.value === selectedOption);
    const displayValue = selectedOptionData ? selectedOptionData.label : selectedOption;
    
    onSubmit(displayValue);
    onNext();
    
    // Reset selection
    setSelectedOption("");
  };

  const canSubmit = selectedOption !== "";

  return (
    <form onSubmit={handleSubmit} className="input-form">
      <div className="referral-options-container">
        <div className="referral-options">
          {question.options.map((option) => (
            <button
              key={option.value}
              type="button"
              className={`referral-button ${selectedOption === option.value ? 'referral-button-selected' : ''}`}
              onClick={() => handleOptionChange(option.value)}
            >
              {option.label}
            </button>
          ))}
        </div>
        <button
          type="submit"
          className="referral-submit-button"
          disabled={!canSubmit}
        >
          Continue
        </button>
      </div>
    </form>
  );
};

export default ReferralQuestion;
